<div class="manage-transmission-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="manage-transmission-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="manage-transmission-shell__sidebar"
    [class.manage-transmission-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-transmission-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-transmission-shell__content">
    <app-dashboard-header [title]="''" [subtitle]="''" [user]="user" [currentTime]="''" (menuToggle)="handleMenuToggle()" />

    <main class="manage-transmission-page">
      <section class="manage-transmission-page__panel app-card">
        <div class="manage-transmission-page__panel-header">
          <div class="manage-transmission-page__heading-copy">
            <h2 class="app-title-serif">Manage Transmission Lines</h2>
          </div>

          <button type="button" class="app-button app-button--primary manage-transmission-page__add-button" (click)="openAddTransmissionLineModal()">
            <span class="manage-transmission-page__add-icon">+</span>
            <span>Add New Transmission Line</span>
          </button>
        </div>

        <div class="manage-transmission-page__panel-body">
          <form class="manage-transmission-filters" [formGroup]="filterForm">
            <label class="app-form-field manage-transmission-filters__field manage-transmission-filters__field--search">
              <span class="app-form-label">Search</span>
              <div class="manage-transmission-filters__search">
                <span class="manage-transmission-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input class="app-form-input manage-transmission-filters__search-input" type="text" placeholder="Search" formControlName="search" />
              </div>
            </label>

            <label class="app-form-field manage-transmission-filters__field">
              <span class="app-form-label">From Substation</span>
              <select class="app-form-select" formControlName="from_substation_id">
                <option value="all">All Substations</option>
                @for (substation of substationOptions; track substation.id) {
                  <option [ngValue]="substation.id">{{ substation.name }}</option>
                }
              </select>
            </label>

            <label class="app-form-field manage-transmission-filters__field">
              <span class="app-form-label">To Substation</span>
              <select class="app-form-select" formControlName="to_substation_id">
                <option value="all">All Substations</option>
                @for (substation of substationOptions; track substation.id) {
                  <option [ngValue]="substation.id">{{ substation.name }}</option>
                }
              </select>
            </label>

            <label class="app-form-field manage-transmission-filters__field">
              <span class="app-form-label">Voltage Level</span>
              <select class="app-form-select" formControlName="voltage_level_id">
                <option value="all">All Voltage Levels</option>
                @for (voltageLevel of voltageLevelOptions; track voltageLevel.id) {
                  <option [ngValue]="voltageLevel.id">{{ voltageLevel.name }}</option>
                }
              </select>
            </label>

            <div class="manage-transmission-filters__clear">
              <button
                type="button"
                class="app-button app-button--secondary equal app-filter-actions__button"
                [disabled]="isLoading || isExporting"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>

            <div class="manage-transmission-filters__actions">
              <button
                type="button"
                class="app-button app-button--secondary manage-transmission-filters__menu-button app-action-menu-trigger"
                [class.manage-transmission-filters__menu-button--open]="isTransmissionActionMenuOpen"
                [class.app-action-menu-trigger--open]="isTransmissionActionMenuOpen"
                [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                (click)="toggleTransmissionActionMenu()"
                aria-label="Open transmission line actions"
              >
                <svg class="manage-transmission-filters__menu-icon app-action-menu-trigger__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <circle cx="12" cy="5.5" r="1.5"></circle>
                  <circle cx="12" cy="12" r="1.5"></circle>
                  <circle cx="12" cy="18.5" r="1.5"></circle>
                </svg>
              </button>

              @if (isTransmissionActionMenuOpen) {
                <div class="manage-transmission-filters__menu app-action-menu-panel">
                  <button
                    type="button"
                    class="app-button app-button--secondary manage-transmission-filters__menu-item app-action-menu-item"
                    title="Export Data"
                    aria-label="Export Data"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="exportTransmissionLineData()"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-file-export" aria-hidden="true"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    class="app-button app-button--secondary manage-transmission-filters__menu-item app-action-menu-item"
                    title="Download Template"
                    aria-label="Download Template"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="downloadTransmissionLineTemplate()"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-download" aria-hidden="true"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    class="app-button app-button--primary manage-transmission-filters__menu-item app-action-menu-item"
                    title="Import Data"
                    aria-label="Import Data"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="triggerTransmissionImportFilePicker(transmissionImportInput)"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-file-import" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
              }
              <input
                #transmissionImportInput
                type="file"
                class="manage-transmission-filters__import-input"
                accept=".xlsx"
                (change)="onTransmissionImportFileSelected($event)"
              />
            </div>
          </form>

          <div class="manage-transmission-page__table-wrap app-table-scroll">
            <table class="manage-transmission-table">
              <thead>
                <tr>
                  <th>S.No.</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('line_name')" [attr.aria-label]="'Sort by Line Name'"><span>Line Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('line_name')" [class.manage-sort-icon--descending]="isSortDescending('line_name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('scada_code')" [attr.aria-label]="'Sort by SCADA Code'"><span>SCADA Code</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('scada_code')" [class.manage-sort-icon--descending]="isSortDescending('scada_code')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>From Substation</th>
                  <th>To Substation</th>
                  <th>Voltage Level</th>
                  <th>No. of Circuit</th>
                  <th>Length (km)</th>
                  <th>Circuit Km</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('total_capacity')" [attr.aria-label]="'Sort by Total Capacity'"><span>Total Capacity</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('total_capacity')" [class.manage-sort-icon--descending]="isSortDescending('total_capacity')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>File</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td colspan="12" class="manage-transmission-page__empty-state">Loading transmission lines...</td>
                  </tr>
                } @else if (filteredLines.length) {
                  @for (item of filteredLines; track trackByLineId($index, item)) {
                    <tr>
                      <td>{{ item.serial_no ?? '-' }}</td>
                      <td>{{ item.transmission_line_name }}</td>
                      <td>{{ item.scada_code || '-' }}</td>
                      <td>{{ item.from_substation_name || getSubstationName(item.from_substation_id) }}</td>
                      <td>{{ item.to_substation_name || getSubstationName(item.to_substation_id) }}</td>
                      <td>{{ item.voltage_level_label || getVoltageLevelLabel(item.voltage_level_id) }}</td>
                      <td>{{ item.no_of_circuit }}</td>
                      <td>{{ item.length_km ?? '-' }}</td>
                      <td>{{ item.circuit_km ?? '-' }}</td>
                      <td>{{ item.total_capacity_mva ?? '-' }}</td>
                      <td>{{ item.file_path ? 'Available' : '-' }}</td>
                      <td>
                        <div class="manage-transmission-page__actions">
                          <div class="app-row-action-menu">
                            <details class="app-row-action-menu__details">
                              <summary class="app-row-action-menu__toggle" aria-label="Open transmission line actions">
                                <span class="app-row-action-menu__dots" aria-hidden="true">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewTransmissionLineModal(item)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                      <circle cx="12" cy="12" r="2.8"></circle>
                                    </svg>
                                  </span>
                                  <span>View</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditTransmissionLineModal(item)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                      <path d="m13.5 6.5 4 4"></path>
                                    </svg>
                                  </span>
                                  <span>Edit</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteTransmissionLineModal(item)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M3 6h18"></path>
                                      <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                      <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                      <path d="M10 10v6"></path>
                                      <path d="M14 10v6"></path>
                                    </svg>
                                  </span>
                                  <span>Delete</span>
                                </button>
                              </div>
                            </details>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td colspan="12" class="manage-transmission-page__empty-state">No transmission lines found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (canShowPagination()) {
            <div class="manage-transmission-page__pagination">
              <div class="manage-transmission-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="manage-transmission-page__pagination-actions">
                <button type="button" class="app-button app-button--secondary manage-transmission-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">Previous</button>

                <div class="manage-transmission-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="manage-transmission-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button
                        type="button"
                        class="manage-transmission-page__pagination-page"
                        [class.manage-transmission-page__pagination-page--active]="pagination.page_no === page"
                        [disabled]="isLoading"
                        (click)="goToPage(page)"
                      >
                        {{ page }}
                      </button>
                    }
                  }
                </div>

                <button type="button" class="app-button app-button--secondary manage-transmission-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">Next</button>
              </div>

              <label class="manage-transmission-page__pagination-size">
                <span class="manage-transmission-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select manage-transmission-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </section>
    </main>
  </div>

  @if (modalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-transmission-modal" open>
        <div class="manage-transmission-modal__header">
          <div>
            <h3 class="app-title-serif">
              {{
                modalMode === 'edit'
                  ? 'Edit Transmission Line'
                  : modalMode === 'view'
                    ? 'View Transmission Line'
                    : 'Add Transmission Line Setup'
              }}
            </h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-transmission-modal__close" aria-label="Close modal" (click)="closeTransmissionLineModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="transmissionLineForm" (ngSubmit)="saveTransmissionLine()">
          <div class="manage-transmission-modal__body">
            @if (submitErrorMessage) {
              <section class="manage-transmission-modal__alert app-form-error">{{ submitErrorMessage }}</section>
            }

            <div class="manage-transmission-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">From Substation</span>
                <select class="app-form-select" formControlName="from_substation_id">
                  <option [ngValue]="null">Select Substation</option>
                  @for (substation of substationOptions; track substation.id) {
                    <option [ngValue]="substation.id">{{ substation.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">To Substation</span>
                <select class="app-form-select" formControlName="to_substation_id">
                  <option [ngValue]="null">Select Substation</option>
                  @for (substation of substationOptions; track substation.id) {
                    <option [ngValue]="substation.id">{{ substation.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Voltage Level (kV) <span class="manage-transmission-modal__required">*</span></span>
                <select class="app-form-select" formControlName="voltage_level_id">
                  <option [ngValue]="null">Select Voltage Level</option>
                  @for (voltageLevel of voltageLevelOptions; track voltageLevel.id) {
                    <option [ngValue]="voltageLevel.id">{{ voltageLevel.name }}</option>
                  }
                </select>
                @if (isRequiredFieldInvalid('voltage_level_id')) {
                  <section class="app-form-error">Voltage level is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Transmission Line Name</span>
                <input class="app-form-input" type="text" formControlName="transmission_line_name" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">SCADA Code</span>
                <input class="app-form-input" type="text" placeholder="SCADA code" formControlName="scada_code" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Parameter</span>
                <select class="app-form-select" formControlName="parameter">
                  <option [ngValue]="''">Select Parameter</option>
                  @for (option of parameterOptions; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Logsheet</span>
                <select class="app-form-select" formControlName="logsheet">
                  @for (option of logsheetOptions; track option.label) {
                    <option [ngValue]="option.value">{{ option.label }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">No. of Circuit</span>
                <input class="app-form-input" type="number" placeholder="e.g. 1, 2" formControlName="no_of_circuit" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Length (km)</span>
                <input class="app-form-input" type="text" placeholder="Length in km" formControlName="length_km" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Circuit Km</span>
                <input class="app-form-input" type="text" formControlName="circuit_km" readonly />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Per Circuit (Ampere)</span>
                <input class="app-form-input" type="text" placeholder="Per circuit ampere" formControlName="per_circuit_ampere" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Per Circuit (MVA)</span>
                <input class="app-form-input" type="text" placeholder="Per circuit mva" formControlName="per_circuit_mva" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Total Capacity (MVA)</span>
                <input class="app-form-input" type="text" formControlName="total_capacity_mva" readonly />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Conductor Code Name</span>
                <input class="app-form-input" type="text" placeholder="Conductor code name" formControlName="conductor_code_name" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Bundle</span>
                <select class="app-form-select" formControlName="bundle">
                  <option [ngValue]="''">Select Bundle</option>
                  @for (bundle of bundleOptions; track bundle.value) {
                    <option [value]="bundle.value">{{ bundle.label }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Conductor Type</span>
                <input class="app-form-input" type="text" placeholder="Conductor type" formControlName="conductor_type" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">No of Towers</span>
                <input class="app-form-input" type="number" placeholder="No of towers" formControlName="no_of_towers" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Starting Tower No</span>
                <input class="app-form-input" type="text" placeholder="Starting tower no" formControlName="starting_tower_no" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Ending Tower No</span>
                <input class="app-form-input" type="text" placeholder="Ending tower no" formControlName="ending_tower_no" />
              </label>

              <label class="app-form-field manage-transmission-modal__field--wide">
                <span class="app-form-label">File</span>
                <div class="manage-transmission-modal__file-row">
                  <input #fileInput class="app-form-input" type="file" [disabled]="modalMode === 'view'" (change)="onFileSelected($event)" />
                  <div class="manage-transmission-modal__file-actions" *ngIf="hasAnyFile()">
                    <button type="button" class="app-button app-button--secondary manage-transmission-modal__file-button" [disabled]="!hasFilePreview()" (click)="previewSelectedFile()">Preview</button>
                    @if (modalMode !== 'view') {
                      <button type="button" class="app-button app-button--secondary manage-transmission-modal__file-button manage-transmission-modal__file-button--danger" (click)="removeSelectedFile(fileInput)">X</button>
                    }
                  </div>
                </div>
                <small class="manage-transmission-modal__file-hint">{{ getFilePreviewLabel() }}</small>
              </label>

              <div class="app-form-field manage-transmission-modal__field--inline">
                <span class="app-form-label">Is Crossborder?</span>
                <label class="manage-transmission-modal__switch">
                  <input type="checkbox" formControlName="is_crossborder" />
                  <span>Yes</span>
                </label>
              </div>
            </div>

            <section class="manage-transmission-modal__fibers">
              <div class="manage-transmission-modal__fibers-header">
                <h4>Optical Fiber Details</h4>
                @if (modalMode !== 'view') {
                  <button type="button" class="app-button app-button--primary manage-transmission-modal__add-more" (click)="addOpticalFiberRow()">+ Add More</button>
                }
              </div>

              <div class="manage-transmission-modal__fiber-list" formArrayName="optical_fiber_details">
                @for (fiberGroup of opticalFiberControls; track $index) {
                  <div class="manage-transmission-modal__fiber-row" [formGroupName]="$index">
                    <div class="manage-transmission-modal__fiber-index">{{ $index + 1 }}</div>

                    <label class="app-form-field">
                      <span class="app-form-label">No of Core</span>
                      <input class="app-form-input" type="number" placeholder="No of core" formControlName="no_of_core" />
                    </label>

                    <label class="app-form-field">
                      <span class="app-form-label">Length of Optical Fiber (km)</span>
                      <input class="app-form-input" type="text" placeholder="Length in km" formControlName="length_of_optical_fiber_km" />
                    </label>

                    <label class="app-form-field">
                      <span class="app-form-label">Type</span>
                      <select class="app-form-select" formControlName="fiber_type">
                        <option [ngValue]="''">Select</option>
                        @for (option of fiberTypeOptions; track option.value) {
                          <option [value]="option.value">{{ option.label }}</option>
                        }
                      </select>
                    </label>

                    <label class="app-form-field">
                      <span class="app-form-label">Use</span>
                      <select class="app-form-select" formControlName="fiber_use">
                        <option [ngValue]="''">Select</option>
                        @for (option of fiberUseOptions; track option.value) {
                          <option [value]="option.value">{{ option.label }}</option>
                        }
                      </select>
                    </label>

                    <label class="app-form-field">
                      <span class="app-form-label">Spark</span>
                      <input class="app-form-input" type="text" placeholder="Spark" formControlName="spark" />
                    </label>

                    <div class="manage-transmission-modal__fiber-actions">
                      @if (modalMode !== 'view') {
                        <button
                          type="button"
                          class="app-button app-button--icon manage-transmission-modal__fiber-remove"
                          aria-label="Remove optical fiber row"
                          (click)="removeOpticalFiberRow($index)"
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                            <path d="M6 6 18 18"></path>
                            <path d="M18 6 6 18"></path>
                          </svg>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            </section>
          </div>

          <div class="manage-transmission-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeTransmissionLineModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedTransmissionLine) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-transmission-delete">
        <div class="manage-transmission-delete__header">
          <div class="manage-transmission-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Transmission Line</h3>
            <p>This action cannot be undone</p>
          </div>
        </div>

        <p class="manage-transmission-delete__copy">
          Are you sure you want to delete <strong>{{ selectedTransmissionLine.transmission_line_name }}</strong>?
        </p>

        <div class="manage-transmission-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }
</div>
